import { render, staticRenderFns } from "./MyTabs.vue?vue&type=template&id=33f59c13&scoped=true"
import script from "./MyTabs.vue?vue&type=script&lang=js"
export * from "./MyTabs.vue?vue&type=script&lang=js"
import style0 from "./MyTabs.vue?vue&type=style&index=0&id=33f59c13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f59c13",
  null
  
)

export default component.exports